import type { Path } from '@cobliteam/api-lib/src/__generated__/graphql';
import { useGetImages } from '@cobliteam/hooks/src/useCamera/useFaceId';
import Image from '@cobliteam/ui/components/Image';
import { TableCell } from '@cobliteam/ui/components/Table';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import { DriverImagesCarousel } from '@cobliteam/ui-business/components';
import { ReactComponent as SadFace } from '@cobliteam/ui-business/icons/face-id/sad-face.svg';

interface PhotosColumnProps {
  path: Path;
}

const PhotosColumn = ({ path }: PhotosColumnProps) => {
  const { startTime, endTime, vehicle } = path;

  const { data: images = { content: [] }, isLoading } = useGetImages(vehicle?.id || '', {
    fromTimestamp: new Date(startTime).toISOString(),
    toTimestamp: new Date(endTime).toISOString(),
    page: 0,
    size: 100,
  });

  if (isLoading) {
    return (
      <div className='flex aspect-video w-36 flex-col items-center justify-center gap-1 rounded-md bg-gray-5 text-gray-8'>
        <Icon name='cb-loading-spin' />
      </div>
    );
  }

  if (images?.content.length === 0) {
    return (
      <div className='flex aspect-video w-36 flex-col items-center justify-center gap-1 rounded-md bg-gray-5 text-gray-8'>
        <SadFace className='size-4' />
        <Typography variant='caption-default' className='text-gray-8'>
          Sem fotos
        </Typography>
      </div>
    );
  }

  const imagesUrls = images?.content.map((image) => image.url) || [];

  return (
    <TableCell className='p-0'>
      <DriverImagesCarousel carouselImages={imagesUrls} className='h-fit' showRemoveButton={false}>
        <div className='group relative flex aspect-video w-36 items-center justify-center overflow-hidden rounded-md'>
          <Image src={imagesUrls[0]} alt='Foto do trecho' className='h-full w-full object-cover' />
          <div className='absolute inset-0 flex items-center justify-center opacity-0 transition-opacity group-hover:opacity-100'>
            <Icon name='images' size='md' color='white' className='box-content overflow-visible rounded-full bg-black-a7 p-3' />
          </div>
        </div>
      </DriverImagesCarousel>
    </TableCell>
  );
};

export default PhotosColumn;
